function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import _ from 'underscore';
var BaseComponent = /*#__PURE__*/function () {
  function BaseComponent() {
    _classCallCheck(this, BaseComponent);
    this.resizeTimer = 100;
    this.scrollTimer = 50;
    this.events = [];
    this.setupWindowEvents();
    this.setupWindowResize();
  }
  _createClass(BaseComponent, [{
    key: "addEvent",
    value: function addEvent(selector, eventName, callback) {
      this.events.push(this.element.find(selector).on(eventName, function (e) {
        return callback(e);
      }));
    }
  }, {
    key: "setupWindowResize",
    value: function setupWindowResize() {
      var _this = this;
      if (typeof this.onWindowResize !== 'undefined') {
        _.debounce(function () {
          _this.onWindowResize();
        }, 100);
      }
    }
  }, {
    key: "setupWindowEvents",
    value: function setupWindowEvents() {
      var _this2 = this;
      if (typeof this.onWindowResize !== 'undefined') {
        $(window).on('resize', _.debounce(function () {
          _this2.onWindowResize();
        }, this.resizeTimer));
      }
      if (typeof this.onWindowScroll !== 'undefined') {
        $(window).on('scroll', _.debounce(function () {
          _this2.onWindowScroll();
        }, this.scrollTimer));
      }
    }
  }, {
    key: "childElements",
    value: function childElements(selector) {
      if (this.element) {
        return this.element.find(selector);
      }
      return null;
    }
  }, {
    key: "domElement",
    value: function domElement() {
      return this.element.get(0);
    }
  }]);
  return BaseComponent;
}();
export { BaseComponent as default };